// Mesmos valores aceitos pelo backend (CreateEducationalContentDto).
export const CATEGORY_OPTIONS = [
 { value: 'aula', label: 'Aula' },
 { value: 'material', label: 'Material' },
 { value: 'treinamentos', label: 'Treinamentos' },
];

export function categoryLabel(value) {
 return CATEGORY_OPTIONS.find((option) => option.value === value)?.label || value;
}
